<template>
<v-dialog
      v-model="alertConfirm.open"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ alertConfirm.title }}
        </v-card-title>
        <v-card-text>{{alertConfirm.message}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="cancel()"
          >
            {{ alertConfirm.buttonCancelText ? alertConfirm.buttonCancelText : 'Cancelar' }}
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="confirm()"
          >
            {{ alertConfirm.buttonConfirmText ? alertConfirm.buttonConfirmText : 'Confirmar' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { useGlobalActionsStore } from '../../stores/GlobalActionsStore'
export default {
    data(){
        return {
            alertConfirm: useGlobalActionsStore().alertConfirm
        }
    },
    methods:{
        cancel(){
            this.alertConfirm.onCancel();
            this.alertConfirm.open = false;
        },
        confirm(){
            this.alertConfirm.onConfirm();
            this.alertConfirm.open = false;
        }
    }
}
</script>

<style>

</style>
